var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-iij058",
    focusable: "false",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "#F6F9FC",
    stroke: "#FF8082",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4527_1342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 5.16663C7.78008 5.16663 5.16675 7.77996 5.16675 11C5.16675 14.22 7.78008 16.8333 11.0001 16.8333C14.2201 16.8333 16.8334 14.22 16.8334 11C16.8334 7.77996 14.2201 5.16663 11.0001 5.16663ZM13.3334 11.5833H8.66675C8.34591 11.5833 8.08342 11.3208 8.08342 11C8.08342 10.6791 8.34591 10.4166 8.66675 10.4166H13.3334C13.6542 10.4166 13.9167 10.6791 13.9167 11C13.9167 11.3208 13.6542 11.5833 13.3334 11.5833Z",
    fill: "#FF8082"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4527_1342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stopIcon.c245d50b55d1f75a692e68159d301e6e.svg";
export { ForwardRef as ReactComponent };